import type { EnrichedContentIndexable } from "@/src/models/blocks/enriched-content";
import { StediEligibilityCheck } from "@/src/models/stedi-eligibility-check";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getEligibilityCheckByReferralId(referralId: string): Promise<StediEligibilityCheck | null> {
  return fetchJSON<StediEligibilityCheck | null>(`/api/referrals/${referralId}/eligibility`);
}

export async function getEligibilityCheckByTaskId(taskId: string): Promise<StediEligibilityCheck | null> {
  return fetchJSON<StediEligibilityCheck | null>(`/api/tasks/${taskId}/eligibility`);
}

export type VerifyInsuranceEligibilityResponse = {
  skipped: boolean;
  reason?: string;
  check: StediEligibilityCheck | null;
};

export type VerifyInsuranceEligibilityRequestPayload = {
  enrichedContent: EnrichedContentIndexable;
  force?: boolean;
};

export async function verifyInsuranceEligibilityAtIntake(
  taskId: string,
  payload: VerifyInsuranceEligibilityRequestPayload
): Promise<VerifyInsuranceEligibilityResponse> {
  return fetchJSON<VerifyInsuranceEligibilityResponse>(`/api/tasks/${taskId}/verify-insurance-eligibility`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
